import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { LegalPage } from './LegalPage';
import { TERMS } from './legal-content';

export default function TermsOfService() {
    return (
        <LegalPage
            icon={FileText}
            content={TERMS}
            extraFooter={
                <>
                    <Link to="/privacy" className="text-[hsl(var(--accent))] underline">Privacy Policy</Link>
                    {' · '}
                    <Link to="/cookies" className="text-[hsl(var(--accent))] underline">Cookie Policy</Link>
                </>
            }
        />
    );
}
